<template>
  <div v-if="model.params.done">
    <span v-if="!model.hasTransport" v-translate>
      There are no more seats available for your search.
      Please change your search criteria.
    </span>
    <span v-else-if="model.results">
      <b><translate>Search results</translate>: {{ model.params.resortName}} - {{ model.params.duration }} <translate>nights</translate>:</b>
      <strong>&nbsp;{{ model.results.length }}</strong> <translate>results</translate>
      <!-- {{ model.results}} -->
    </span>
    <span v-else v-translate>
      There are no more seats available for your search.
      Please change your search criteria.
    </span>
  </div>
</template>

<script>
import model from '../services/model'
export default {
  name: 'SearchResultsSummary',
  params: ['params'],
  data () {
    return {
      model
    }
  }
}
</script>
